import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { YouTubeChannel } from "../youtubechannel.types";
import AccessTokenStateChip from "./AcessTokenStateChip";
import ReauthStateChip from "./ReauthStateChip";

interface ColumnActions {
  onReauthenticate: (channel: YouTubeChannel) => void;
  canReauthenticate?: boolean;
}

export function getYouTubeChannelColumns({
  onReauthenticate,
  canReauthenticate = true,
}: ColumnActions): GridColDef<YouTubeChannel>[] {
  return [
    {
      field: "company",
      headerName: "Company",
      flex: 1,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <Typography fontWeight={600}>
          {params.row.company?.name || "-"}
        </Typography>
      ),
    },
    {
      field: "display_name",
      headerName: "Display Name",
      flex: 1.2,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <Typography sx={{ whiteSpace: "normal", lineHeight: 1.3, py: 1 }}>
          {params.row.display_name || "-"}
        </Typography>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },
    {
      field: "needs_reauth",
      headerName: "Re-auth",
      flex: 0.8,
      sortable: false,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <ReauthStateChip needsReauth={params.row.needs_reauth} />
      ),
    },
    {
      field: "access_token_preview",
      headerName: "Access Token",
      flex: 1,
      sortable: false,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <AccessTokenStateChip value={params.row.access_token_preview} />
      ),
    },
    {
      field: "token_expiry",
      headerName: "Expires",
      flex: 1,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <Typography color={params.row.needs_reauth ? "error" : "success.main"}>
          {params.row.token_expiry || "-"}
        </Typography>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.8,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<YouTubeChannel>) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {params.row.needs_reauth && canReauthenticate && (
            <Tooltip title="Re-authenticate" arrow>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  onReauthenticate(params.row);
                }}
                sx={{
                  color: "#F59E0B",
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];
}
